import React from "react";

export default function QuoteDocumentInfo({ header, setHeader, disabled }) {
  const detail = header?.Doc_Detail ?? "";
  const remark = header?.Doc_Remark ?? "";

  return (
    <div className="bg-white shadow rounded-lg p-4 border border-gray-200">
      <h2 className="text-lg font-semibold mb-3">รายละเอียดเอกสาร</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 whitespace-nowrap">
            รายละเอียดเพิ่มเติม
          </label>
          <textarea
            rows={4}
            value={detail}
            onChange={(e) =>
              setHeader((prev) => ({ ...prev, Doc_Detail: e.target.value }))
            }
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            หมายเหตุ
          </label>
          <textarea
            rows={4}
            value={remark}
            onChange={(e) =>
              setHeader((prev) => ({ ...prev, Doc_Remark: e.target.value }))
            }
            className="w-full border border-gray-300 rounded-md px-3 py-2"
          />
        </div>

      </div>
    </div>
  );
}

